import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {AppConfigService} from '../../../../Services/app-config.service';
import {NotificationService} from '../../../../Services/notification.service';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../../Services/ngbpagination-config.service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-salesperson-list',
  templateUrl: './salesperson-list.component.html',
  styleUrls: ['./salesperson-list.component.css'],
  standalone: false
})
export class SalespersonListComponent extends ListPageBase implements OnInit {
  constructor(
    private aTable: DataService,
    private aToastr: NotificationService,
    private aRoute: Router,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  isLoading = false;


  vm: any = [];

  ngOnInit(): void {
    this.titleService.setTitle($localize`:Salesperson List@@salespersonList:Salesperson List`);
    this.vm.list = [];
    this.restorePagerState();
    this.getData();
  }

  getData(): void {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('salesperson', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.isLoading = true;
      },
      (error: HttpErrorResponse) => {
        this.aToastr.error($localize`:Error loading Salesperson Data@@errorLoadingSalespersonData:Error loading Salesperson Data`);
        console.log(error);
      },
      () => {
      }
    );
  }

  onNavigate(aID: string): void {
    this.aRoute.navigate(['admin/salesperson-form', {id: aID}]);
  }

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData(): void {
    let paramString = '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString += '&fromDate=' + (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString += '&toDate=' + (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('salesperson', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.isLoading = true;
      },
      (error: HttpErrorResponse) => {
        this.aToastr.error($localize`:Error loading Salesperson Data@@errorLoadingSalespersonData:Error loading Salesperson Data`);
        console.log(error);
      },
      () => {
      }
    );
  }

  serverSearch(value: any): void {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value: any): void {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch(): void {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
